import type { Manga } from "@/mocks/manga";

interface MangaCardProps {
  manga: Manga;
  showProgress?: boolean;
}

export default function MangaCard({ manga, showProgress = true }: MangaCardProps) {
  return (
    <a
      href={`#completed`}
      className="group block overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200 transition duration-300 hover:-translate-y-1 hover:ring-primary-300"
      title={`${manga.title} - ${manga.status}，进度${manga.progress}%`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={manga.cover}
          alt={`${manga.title} 漫画封面，${manga.status}${manga.category}`}
          title={`${manga.title} 漫画 ${manga.latestChapter}`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-xs font-medium text-background-50 ${
            manga.status === "连载中" ? "bg-primary-500" : "bg-foreground-800"
          }`}
        >
          {manga.status}
        </span>
        {manga.isHot && (
          <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-xs text-foreground-950">
            <i className="ri-fire-fill"></i>
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent px-2 pb-2 pt-8 text-xs text-background-50 opacity-0 transition duration-300 group-hover:opacity-100">
          <span className="whitespace-nowrap">{manga.latestChapter}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950">
          <span className="text-primary-600">{manga.title}</span>
        </h3>
        <p className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
          <span>{manga.category}</span>
          <span className="text-foreground-300">·</span>
          <span className="truncate">{manga.latestChapter}</span>
        </p>
        {showProgress && (
          <div className="mt-2.5">
            <div className="mb-1 flex items-center justify-between text-[11px] text-foreground-500">
              <span>追更进度</span>
              <span>{manga.progress}%</span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
              <div
                className={`h-full rounded-full ${
                  manga.status === "连载中" ? "bg-primary-500" : "bg-accent-500"
                }`}
                style={{ width: `${manga.progress}%` }}
              ></div>
            </div>
          </div>
        )}
      </div>
    </a>
  );
}